import React, {Component} from 'react';
import {connect} from 'react-redux';
import {sumBy} from 'lodash';
import {Table, Card, Dropdown} from 'semantic-ui-react';
import {pageSizes} from '../../common/constants/lists';
import {Actions} from '../../common/actions';
import {getNumericValue} from '../../common/util/fieldsValidation';
import TablePaginator from '../../common/components/tablePaginator';

const typeOptions = {
  'P': 'Presupuesto',
  'V': 'Venta',
};

class SalesAndBudgetsTable extends Component {
  constructor(props) {
    super(props);
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
    this.onPageClick = this.onPageClick.bind(this);
  }

  onPageClick(value) {
    this.props.changeSalesAndBudgetsListPage(value);
  }

  onPageSizeClick(event, data) {
    this.props.changeSalesAndBudgetsListPageSize(data.value);
  }

  renderPagination() {
    const {pageNumber, pageSize, totalItems} = this.props;

    if (totalItems <= pageSize) {
      return null;
    }
    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick}
                />
              </span>
              <TablePaginator
                itemsCount={totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  renderTotals() {
    const {salesAndBudgetsList} = this.props;
    const total = sumBy(salesAndBudgetsList, 'amount');
    return (
      <Table.Row className='totals-row'>
        <Table.Cell textAlign='center' colSpan={1}>
          <span>TOTAL</span>
        </Table.Cell>
        <Table.Cell colSpan={4}></Table.Cell>
        <Table.Cell textAlign='center' colSpan={1}>
          <span>
            {'$'}
            {getNumericValue(total, 2)}
          </span>
        </Table.Cell>
      </Table.Row>
    );
  }

  renderItemRows() {
    const {salesAndBudgetsByPage} = this.props;
    return salesAndBudgetsByPage.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.dealerRuc}</Table.Cell>
          <Table.Cell textAlign='center'>{element.agency}</Table.Cell>
          <Table.Cell textAlign='center'>
            {typeOptions[element.type]}
          </Table.Cell>
          <Table.Cell textAlign='center'>{element.year}</Table.Cell>
          <Table.Cell textAlign='center'>{element.month}</Table.Cell>
          <Table.Cell textAlign='center'>
            {'$'}
            {getNumericValue(element.amount, 2)}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderDatatable() {
    const {salesAndBudgetsByPage} = this.props;
    if (!salesAndBudgetsByPage.length) {
      return null;
    }
    return (
      <Card fluid raised>
        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>
                Ruc Concesionario
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Agencia</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Tipo</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Año</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Mes</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Monto</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {this.renderItemRows()}
            {this.renderTotals()}
          </Table.Body>

          {this.renderPagination()}
        </Table>
      </Card>
    );
  }

  renderErrors() {
    const {errors} = this.props;
    return errors.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.row}</Table.Cell>
          <Table.Cell textAlign='center'>{element.message}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderErrorsTable() {
    return (
      <Card fluid raised>
        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>Fila</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Errores</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>{this.renderErrors()}</Table.Body>
        </Table>
      </Card>
    );
  }

  renderErrorsOrData() {
    const {showData, errors} = this.props;
    if (!showData) {
      return null;
    }
    if (errors.length) {
      return this.renderErrorsTable();
    }
    return this.renderDatatable();
  }

  render() {
    return this.renderErrorsOrData();
  }
}

const mapStateToProps = (state) => {
  return {
    'salesAndBudgetsByPage': state.salesAndBudgetsLoad.page,
    'salesAndBudgetsList': state.salesAndBudgetsLoad.list,
    'pageNumber': state.salesAndBudgetsLoad.pageNumber,
    'pageSize': state.salesAndBudgetsLoad.pageSize,
    'totalItems': state.salesAndBudgetsLoad.list.length,
  };
};

const {
  changeSalesAndBudgetsListPage,
  changeSalesAndBudgetsListPageSize,
} = Actions;

export default connect(mapStateToProps, {
  changeSalesAndBudgetsListPage,
  changeSalesAndBudgetsListPageSize,
})(SalesAndBudgetsTable);
